var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-textarea",
    _vm._b(
      {
        ref: "textarea",
        staticClass: "code",
        attrs: {
          spellcheck: "false",
          rows: _vm.numberOfRows,
          counter: "",
          value: _vm.value
        },
        on: {
          keydown: _vm.handleKeydown,
          input: function($event) {
            return _vm.updateValue($event)
          }
        }
      },
      "v-textarea",
      _vm.$attrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }